export const PERSONALISED_APPS_TEAM_TYPES = {
	marketing: 'Business Management and Operations',
	itSupport: 'IT Support',
	softwareDevelopment: 'Software Development',
} as const;
